import { routerStyxie } from '@/router/styxieBridge'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

// Router page inside the geogrids shell — same boot as scheduled/live.
Styxie.Initializers.KeywordGroups = routerStyxie({
  actions: ['index'],
  hydrate: (props, pinia) => useGeogridsCommonStore(pinia).initialize(props)
})
